<div class="precast-edit-wrapper" id="precast-edit-wrapper">
  <h2 mat-dialog-title class="mat-h2">
    Pre Cast Data
    <button mat-icon-button class="close-button" (click)="closeDialog('')">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>
    <form [formGroup]="editWorksheetForm">
      <div class="col-12">
        <h1 class="mat-h1 list-title">
          @if (worksheetRow?.status) {
            <img alt="tag" class="ml-8 mr-8 tick" src="../../../../assets/icons/Check.svg" />
          }
          <span class="breakWord">{{ worksheetRow.inHouseId }}</span> Sample Data
        </h1>
      </div>
      <mat-error>{{errorMsg}} </mat-error>
      @if (titleError) {
        <mat-error>In House ID is duplicate. Please enter unique In House ID.</mat-error>
      }
      @if (!validWeight) {
        <mat-error
          >Dry weight cannot be higher than Wet weight, please check and re-enter.</mat-error
          >
        }
        @if (!validTR) {
          <mat-error>Dry TR cannot be lower than Wet TR, please check test results.</mat-error>
        }
        <div class="n-tab">
          <mat-tab-group animationDuration="0" [(selectedIndex)]="selectedIndex" (selectedTabChange)="onTabChanged()">
            <mat-tab label="MEASUREMENTS">
              <div class="tab-height">
                <div class="row">
                  <div class="col-md-1 pt-12">
                    <img alt="tag" class="icon-alignment" src="../../../../assets/icons/Tag.svg" />
                  </div>
                  <div class="col-md-9 pt-16 mat-subtitle-1 list-title">In-House ID<span class="required">*</span></div>
                  <div class="col-md-2 pt-8">
                    <div class="inputdisabled">
                      <mat-form-field appearance="outline" class="edw-form-field">
                        <input matInput maxlength="5" (keyup)="updateModalTitle()" formControlName="inHouseId" required autocomplete="off"/>
                      </mat-form-field>
                    </div>
                  </div>
                  <mat-divider></mat-divider>
                  <div class="col-md-1 pt-12">
                    <img alt="measure" class="icon-alignment" src="../../../../assets/icons/scale.svg" />
                  </div>
                  <div class="col-md-9 pt-16 mat-subtitle-1 list-title">
                    Tare (gm)
                    <img
                      alt="info Icon"
                      class="star-mar-top"
                      #tooltip="matTooltip"
                      matTooltip="Max. 5 digits allowed, without decimal. e.g. XXXXX"
                      src="../../../../assets/icons/Alert-grey.svg" />
                    </div>
                    <div class="col-md-2 pt-8">
                      <mat-form-field appearance="outline" class="edw-form-field">
                        <input
                          matInput
                          type="text"
                          placeholder="e.g. XXXXX"
                          appRemoveLeadingZero
                          required
                          appOnlyInteger
                          appNumberInput
                          formControlName="tare"
                          (keydown)="onKeyTareDown($event)"
                          autocomplete="off"
                          />
                        </mat-form-field>
                      </div>
                      <div
                        class="row">
                        <mat-divider></mat-divider>
                        <div class="col-md-1 pt-12">
                          <!-- <img alt="measure" class="icon-alignment" src="../../../../assets/icons/scale.svg" /> -->
                        </div>
                        <div class="col-md-9 pt-16 mat-subtitle-1 list-title">
                          Mold (gm)
                          <img
                            alt="info Icon"
                            class="star-mar-top"
                            #tooltip="matTooltip"
                            matTooltip="Max. 5 digits allowed, without decimal. e.g. XXXXX"
                            src="../../../../assets/icons/Alert-grey.svg" />
                          </div>
                          <div class="col-md-2 pt-8">
                            <mat-form-field appearance="outline" class="edw-form-field">
                              <input
                                matInput
                                type="text"
                                placeholder="e.g. XXXXX"
                                appRemoveLeadingZero
                                required
                                appOnlyInteger
                                appNumberInput
                                formControlName="mould"
                                (keydown)="onKeyMoldDown($event)"
                                autocomplete="off"
                                />
                              </mat-form-field>
                            </div>
                          </div>
                          <mat-divider></mat-divider>
                          <div class="col-md-1 pt-12">
                            <img alt="tag" class="icon-alignment" src="../../../../assets/icons/Measure.svg" />
                          </div>
                          <div class="col-md-9 pt-16 mat-subtitle-1 list-title">
                            Sample Diameter (mm)
                            <img
                              alt="info Icon"
                              class="star-mar-top"
                              #tooltip="matTooltip"
                              matTooltip="Max. 4 digits allowed, including one place of decimal. e.g. XXX.X"
                              src="../../../../assets/icons/Alert-grey.svg" />
                            </div>
                            <div class="col-md-2 pt-8">
                              <mat-form-field appearance="outline" class="edw-form-field">
                                <input
                                  matInput
                                  type="text"
                                  placeholder="e.g. XXX.X"
                                  formControlName="sampleDiameter"
                                  required
                                  maxlength="5"
                                  appRemoveLeadingZero
                                  appDecimalOnly
                                  appThreeDigitOneDecimal
                                  (keydown)="onKeySampleDiameterDown($event)"
                                  autocomplete="off"
                                  />
                                </mat-form-field>
                              </div>
                              <mat-divider></mat-divider>
                              <div class="col-md-1 pt-12">
                                <img alt="measure" class="icon-alignment" src="../../../../assets/icons/Measure.svg" />
                              </div>
                              <div class="col-md-9 pt-16 mat-subtitle-1 list-title">
                                Sample Height (mm)
                                <img
                                  alt="info Icon"
                                  class="star-mar-top"
                                  #tooltip="matTooltip"
                                  matTooltip="Max. 4 digits allowed, including one place of decimal. e.g. XXX.X"
                                  src="../../../../assets/icons/Alert-grey.svg" />
                                </div>
                                <div class="col-md-2 pt-8">
                                  <mat-form-field appearance="outline" class="edw-form-field">
                                    <input
                                      matInput
                                      type="text"
                                      placeholder="e.g. XXX.X"
                                      appRemoveLeadingZero
                                      formControlName="sampleHeight"
                                      required
                                      maxlength="5"
                                      appDecimalOnly
                                      appThreeDigitOneDecimal
                                      (keydown)="onKeySampleHeightDown($event)"
                                      autocomplete="off"
                                      />
                                    </mat-form-field>
                                  </div>
                                </div>
                              </div>
                            </mat-tab>
                            <mat-tab label="WET TESTS">
                              <div class="tab-height">
                                <div class="row" formArrayName="multiPointTests">
                                  @for (sample of getmultiPointTests.controls; track sample; let i = $index) {
                                    <ng-container [formGroupName]="i">
                                      <div class="col-md-1 pt-12">
                                        <img alt="measure" class="icon-alignment" src="../../../../assets/icons/scale.svg" />
                                      </div>
                                      <div class="col-md-7 pt-16 mat-subtitle-1 list-title">
                                        Wet + Tare (gm)
                                        <img
                                          alt="info Icon"
                                          class="star-mar-top"
                                          #tooltip="matTooltip"
                                          matTooltip="Max. 5 digits allowed, without decimal. e.g. XXXXX"
                                          src="../../../../assets/icons/Alert-grey.svg" />
                                        </div>
                                        <div class="col-md-2 pt-16" align="right">
                                          @if (getmultiPointTests.length > 1 && i !== 0) {
                                            <button mat-icon-button (click)="removeItem(i)" tabindex="-1">
                                              <mat-icon>delete_outline</mat-icon>
                                            </button>
                                          }
                                        </div>
                                        <div class="col-md-2 pt-8">
                                          <mat-form-field appearance="outline" class="edw-form-field">
                                            <input
                                              matInput
                                              [id]="'wetPlusTare-' + i"
                                              type="text"
                                              placeholder="e.g. XXXXX"
                                              appRemoveLeadingZero
                                              formControlName="wetPlusTare"
                                              required
                                              appOnlyInteger
                                              (keydown)="onKeyWetPlusTareDown($event)"
                                              autocomplete="off"
                                              />
                                            </mat-form-field>
                                          </div>
                                          <div class="col-md-1"></div>
                                          <div class="col-md-11">
                                            <mat-divider></mat-divider>
                                          </div>
                                          <div class="col-md-1"></div>
                                          <div class="col-md-1 pt-12">
                                            <img alt="scale" class="icon-alignment" src="../../../../assets/icons/connecting.svg" />
                                          </div>
                                          <div class="col-md-8 pt-16 mat-subtitle-1 list-title">
                                            Wet TR (C-cm/W)
                                            <img
                                              alt="info Icon"
                                              class="star-mar-top"
                                              #tooltip="matTooltip"
                                              matTooltip="Max. 5 digits allowed, without decimal. e.g. XXXXX"
                                              src="../../../../assets/icons/Alert-grey.svg" />
                                            </div>
                                            <div class="col-md-2 pt-8">
                                              <mat-form-field appearance="outline" class="edw-form-field">
                                                <input
                                                  matInput
                                                  [id]="'wetTr-' + i"
                                                  type="text"
                                                  placeholder="e.g. XXXXX"
                                                  appRemoveLeadingZero
                                                  formControlName="wetTr"
                                                  required
                                                  appOnlyInteger
                                                  (keydown)="onKeyWetTr($event)"
                                                  autocomplete="off"
                                                  />
                                                </mat-form-field>
                                              </div>
                                              <div class="col-md-12">
                                                <mat-divider></mat-divider>
                                              </div>
                                            </ng-container>
                                          }
                                          <div class="col-md-9"></div>
                                          <div class="col-md-3 pt-8" align="right">
                                            @if (getmultiPointTests.length < 10) {
                                              <a mat-button href="javascript:void(0)" (click)="addSample()" tabindex="-2">
                                                + Add Wet TR Test
                                              </a>
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    </mat-tab>
                                    <mat-tab label="DRY TESTS">
                                      <div class="tab-height">
                                        <div class="row">
                                          <div class="col-md-1 pt-12">
                                            <img alt="measure" class="icon-alignment" src="../../../../assets/icons/scale.svg" />
                                          </div>
                                          <div class="col-md-9 pt-16 mat-subtitle-1 list-title">
                                            Dry + Tare (gm)
                                            <img
                                              alt="info Icon"
                                              class="star-mar-top"
                                              #tooltip="matTooltip"
                                              matTooltip="Max. 5 digits allowed, without decimal. e.g. XXXXX"
                                              src="../../../../assets/icons/Alert-grey.svg" />
                                            </div>
                                            <div class="col-md-2 pt-8">
                                              <mat-form-field appearance="outline" class="edw-form-field">
                                                <input
                                                  matInput
                                                  type="text"
                                                  placeholder="e.g. XXXXX"
                                                  appRemoveLeadingZero
                                                  formControlName="dryPlusTare"
                                                  required
                                                  appOnlyInteger
                                                  (keydown)="onKeyDryPlusTareDown($event)"
                                                  autocomplete="off"
                                                  />
                                                </mat-form-field>
                                              </div>
                                              <mat-divider></mat-divider>
                                              <div class="col-md-1 pt-12">
                                                <img alt="scale" class="icon-alignment" src="../../../../assets/icons/connecting.svg" />
                                              </div>
                                              <div class="col-md-9 pt-16 mat-subtitle-1 list-title">
                                                Dry TR (C-cm/W)
                                                <img
                                                  alt="info Icon"
                                                  class="star-mar-top"
                                                  #tooltip="matTooltip"
                                                  matTooltip="Max. 5 digits allowed, without decimal. e.g. XXXXX"
                                                  src="../../../../assets/icons/Alert-grey.svg" />
                                                </div>
                                                <div class="col-md-2 pt-8">
                                                  <mat-form-field appearance="outline" class="edw-form-field">
                                                    <input
                                                      matInput
                                                      type="text"
                                                      placeholder="e.g. XXXXX"
                                                      appRemoveLeadingZero
                                                      formControlName="dryTr"
                                                      required
                                                      appOnlyInteger
                                                      (keydown)="onKeyDryTrDown($event)"
                                                      autocomplete="off"
                                                      />
                                                    </mat-form-field>
                                                  </div>
                                                </div>
                                              </div>
                                            </mat-tab>
                                          </mat-tab-group>
                                        </div>
                                      </form>
                                    </mat-dialog-content>
                                    <mat-divider></mat-divider>
                                    <mat-dialog-actions>
                                      <button
                                        mat-raised-button
                                        [disabled]="currentIndex === 0 || (editWorksheetForm.dirty && !editWorksheetForm.valid)"
                                        (click)="navigateRecords('PREVIOUS')">
                                        <mat-icon>navigate_before</mat-icon>
                                        PREV
                                      </button>
                                      <span class="spacer"></span>
                                      @if (roleCheck(['Manager', 'Admin', 'Labtech'])) {
                                        <button
                                          mat-raised-button
                                          color="primary"
                                          (click)="saveWorksheetData(true)"
                                          [disabled]="!editWorksheetForm.valid"
                                          >
                                          SAVE
                                        </button>
                                      }
                                      @if (currentIndex !== worksheets.length - 1) {
                                        <button
                                          mat-raised-button
                                          class="c-next"
                                          id="next-button"
                                          [disabled]="editWorksheetForm.dirty && !editWorksheetForm.valid"
                                          (click)="navigateRecords('NEXT')">
                                          NEXT<mat-icon>navigate_next</mat-icon>
                                        </button>
                                      }
                                      @if (currentIndex === worksheets.length - 1) {
                                        <button
                                          mat-raised-button
                                          [disabled]="editWorksheetForm.dirty && !editWorksheetForm.valid"
                                          (click)="navigateRecords('DONE')">
                                          DONE
                                        </button>
                                      }
                                    </mat-dialog-actions>
                                  </div>
